/**
 * @description Signup chrome is an app. surface only (LYN-332)
 *
 * Key features:
 * - admin. never shows Sign up / create form, even when LYN-320 is on
 * - app. shows Sign up only when that CP/SO 320 flag is on
 * - Super Admin hosts and localhost are not a CP admin door
 *
 * @dependencies none
 *
 * @notes
 * - Reuses the 320 signupEnabled flag. Does not invent a signup writer.
 * - Bare localhost is LynxPay, not a CP admin door. admin.{slug}.localhost is.
 */

const SUPER_ADMIN_HOSTS = new Set([
  'admin.staging.lynx.build',
  'admin.lynx.build',
  'lynx-admin.pages.dev',
  'main.lynx-admin.pages.dev'
]);

/**
 * @param {string|null|undefined} hostname
 * @returns {string}
 */
export function hostnameOf(hostname) {
  return String(hostname || '').toLowerCase().split(':')[0];
}

/**
 * CP admin. door. Not Super Admin. Not localhost.
 *
 * @param {string|null|undefined} hostname
 * @returns {boolean}
 */
export function isAuthAdminDoor(hostname) {
  const host = hostnameOf(hostname);
  if (!host || SUPER_ADMIN_HOSTS.has(host)) return false;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (/^admin\.[a-z0-9]+(-[a-z0-9]+)*\.staging\.lynx\.build$/.test(host)) return true;
  if (/^admin\.[a-z0-9]+(-[a-z0-9]+)*\.lynx\.build$/.test(host)) return true;
  return host.startsWith('admin.') && !host.endsWith('.lynx.build');
}

/**
 * @param {{
 *   signupEnabled?: boolean|null,
 *   hostname?: string|null
 * }} input
 * @returns {boolean}
 */
export function isSignupChromeAllowed({
  signupEnabled = true,
  hostname = typeof window !== 'undefined' ? window.location.hostname : ''
} = {}) {
  if (isAuthAdminDoor(hostname)) return false;
  return signupEnabled !== false;
}

export default isSignupChromeAllowed;
